import { EditorPlugin, FabricEditor, FabricEditorCanvas } from 'modules/fabric-editor';
import { selectActiveBoard } from 'modules/manager/store';
import React from 'react';
import { useAppSelector } from 'store/hooks';

export interface EditorCanvasProps {
  plugins: EditorPlugin[];
  onReady: (editor: FabricEditor) => void;
}

const EditorCanvas: React.FC<EditorCanvasProps> = ({ plugins, onReady }) => {
  const activeBoard = useAppSelector(selectActiveBoard);

  if (!activeBoard) return null;

  return (
    <FabricEditorCanvas
      key={`${activeBoard.id}-${activeBoard.width}x${activeBoard.height}`}
      resolution={{ width: activeBoard.width, height: activeBoard.height }}
      autoFit
      plugins={plugins}
      onReady={onReady}
      className="flex-1"
    />
  );
};

export default EditorCanvas;
